import { LIST_REGION_PENDING, LIST_REGION_FULFILLED, LIST_REGION_REJECTED,
    LIST_DEPARTMENTS_REGION_PENDING, LIST_DEPARTMENTS_REGION_FULFILLED, LIST_DEPARTMENTS_REGION_REJECTED,
    LIST_SPECIALTY_SKILL_PENDING, LIST_SPECIALTY_SKILL_FULFILLED, LIST_SPECIALTY_SKILL_REJECTED,
    LIST_EQUIPMENTS_PENDING, LIST_EQUIPMENTS_FULFILLED, LIST_EQUIPMENTS_REJECTED, 
    DATA_NEW_LEAD_PENDING, DATA_NEW_LEAD_FULFILLED, DATA_NEW_LEAD_REJECTED,
    DATA_NEW_PROVIDER_PENDING, DATA_NEW_PROVIDER_FULFILLED, DATA_NEW_PROVIDER_REJECTED,
    DATA_NEW_TASK_PENDING, DATA_NEW_TASK_FULFILLED, DATA_NEW_TASK_REJECTED, 
    LIST_DEPARTMENTS_PENDING, LIST_DEPARTMENTS_FULFILLED, LIST_DEPARTMENTS_REJECTED } from './DatasConstants'

const INITIAL_STATE = {
    regions : { pending: false, fulfilled: false, error: null, list:[] },
    departments : { pending: false, fulfilled: false, error: null, list:[], region:null },
    specialties: { pending: false, fulfilled: false, error: null, list:[]  },
    equipments: { pending: false, fulfilled: false, error: null, list:[]  },
    lead: { pending: false, fulfilled: false, error: null, data:[]  },
    provider: { pending: false, fulfilled: false, error: null, data:[]  },
    task: { pending: false, fulfilled: false, error: null, data:[]  },
    all_departments : { pending: false, fulfilled: false, error: null, list:[] },
}

export default (state=INITIAL_STATE, action) => {

    switch (action.type) {
        case LIST_REGION_PENDING:
            return {...state, regions : {...state.regions, pending: true} }
        case LIST_REGION_FULFILLED:
            return {...state, regions : {pending: false, fulfilled: true, list: action.payload.data}}
        case LIST_REGION_REJECTED:
            return {...state, regions : {pending: false, error: action.payload.response }}


        case LIST_DEPARTMENTS_REGION_PENDING:
            return {...state, departments : {...state.departments, pending: true} }
        case LIST_DEPARTMENTS_REGION_FULFILLED:
            return {...state, departments : {pending: false, fulfilled: true, list: action.payload.data.departments, region:action.payload.data.name}}
        case LIST_DEPARTMENTS_REGION_REJECTED:
            return {...state, departments : {pending: false, error: action.payload.response }}


        case LIST_SPECIALTY_SKILL_PENDING:
            return {...state, specialties : {...state.specialties, pending: true} }
        case LIST_SPECIALTY_SKILL_FULFILLED:
            return {...state, specialties : {pending: false, fulfilled: true, list: action.payload.data}}
        case LIST_SPECIALTY_SKILL_REJECTED:
            return {...state, specialties : {pending: false, error: action.payload.response }}


        case LIST_EQUIPMENTS_PENDING:
            return {...state, equipments : {...state.equipments, pending: true} }
        case LIST_EQUIPMENTS_FULFILLED:
            return {...state, equipments : {pending: false, fulfilled: true, list: action.payload.data}}
        case LIST_EQUIPMENTS_REJECTED:
            return {...state, equipments : {pending: false, error: action.payload.response }}

        case DATA_NEW_LEAD_PENDING:
            return {...state, lead:{ ...state.lead, pending: true, fulfilled: false } }
        case DATA_NEW_LEAD_FULFILLED:
            return {...state, lead:{ ...state.lead, pending: false, fulfilled: true, data:action.payload.data } }
        case DATA_NEW_LEAD_REJECTED:
            return {...state, lead:{ ...state.lead, pending: false, error: action.payload.response } }

        case DATA_NEW_PROVIDER_PENDING:
            return {...state, provider:{ ...state.provider, pending: true, fulfilled: false } }
        case DATA_NEW_PROVIDER_FULFILLED:
            return {...state, provider:{ ...state.provider, pending: false, fulfilled: true, data:action.payload.data } }
        case DATA_NEW_PROVIDER_REJECTED:
            return {...state, provider:{ ...state.provider, pending: false, error: action.payload.response } }

        case DATA_NEW_TASK_PENDING:
            return {...state, task:{ ...state.task, pending: true, fulfilled: false } }
        case DATA_NEW_TASK_FULFILLED:
            return {...state, task:{ ...state.task, pending: false, fulfilled: true, data:action.payload.data } }
        case DATA_NEW_TASK_REJECTED:
            return {...state, task:{ ...state.task, pending: false, error: action.payload.response } }


         case LIST_DEPARTMENTS_PENDING:
            return {...state, all_departments : {fulfilled: false, pending: true} }
        case LIST_DEPARTMENTS_FULFILLED:
            return {...state, all_departments : {pending: false, fulfilled: true, list: action.payload.data}}
        case LIST_DEPARTMENTS_REJECTED:
            return {...state, all_departments : {pending: false, error: action.payload.response }}



        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/datas/DatasReducer.js